//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory3Lang', {
//        templateUrl: 'views/components/views/textileModelCategory3Lang/textileModelCategory3Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory3LangService', function ($stateParams, stateService, textileModelCategory3LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory3Keyno = $stateParams.textilemodelcategory3_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await textileModelCategory3LangService.listTextileModelCategory3Languages({ textilemodelcategory3_keyno: textileModelCategory3Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                textileModelCategory3LangService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
